import React from 'react';
import { HardHatIcon, ShovelIcon, ArrowUpFromLineIcon, TruckIcon, ContainerIcon, WrenchIcon } from 'lucide-react';
export function WhatWeCarry() {
  return <section id="equipment" className="w-full bg-brand-dark py-16 md:py-24" aria-labelledby="carry-heading" data-id="element-255">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-256">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16" data-id="element-257">
          <h2 id="carry-heading" className="font-oswald font-bold text-[28px] sm:text-3xl md:text-4xl lg:text-5xl uppercase tracking-wide text-white mb-4" data-id="element-258">
            What We Carry
          </h2>
          <p className="text-brand-muted text-base md:text-lg max-w-2xl mx-auto" data-id="element-259">
            From compact machines to heavy haulers — we stock the equipment
            Arizona contractors rely on every day.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-260">
          {/* Skid Steers */}
          <div className="group bg-brand-card rounded-lg p-8 border border-brand-border hover:border-t-4 hover:border-t-brand-orange hover:border-l-brand-border hover:border-r-brand-border hover:border-b-brand-border transition-all duration-300 cursor-pointer" data-id="element-261">
            <div className="w-14 h-14 rounded-lg bg-brand-orange/10 flex items-center justify-center mb-6" data-id="element-262">
              <HardHatIcon className="w-7 h-7 text-brand-orange" aria-hidden="true" data-id="element-263" />
            </div>
            <h3 className="font-oswald font-semibold text-xl uppercase text-white mb-3" data-id="element-264">
              Skid Steers
            </h3>
            <p className="text-brand-muted text-sm leading-relaxed" data-id="element-265">
              Compact, versatile machines for grading, loading, and site prep.
              Top brands in stock.
            </p>
          </div>

          {/* Excavators */}
          <div className="group bg-brand-card rounded-lg p-8 border border-brand-border hover:border-t-4 hover:border-t-brand-orange hover:border-l-brand-border hover:border-r-brand-border hover:border-b-brand-border transition-all duration-300 cursor-pointer" data-id="element-266">
            <div className="w-14 h-14 rounded-lg bg-brand-orange/10 flex items-center justify-center mb-6" data-id="element-267">
              <ShovelIcon className="w-7 h-7 text-brand-orange" aria-hidden="true" data-id="element-268" />
            </div>
            <h3 className="font-oswald font-semibold text-xl uppercase text-white mb-3" data-id="element-269">
              Excavators
            </h3>
            <p className="text-brand-muted text-sm leading-relaxed" data-id="element-270">
              Mini to full-size excavators for trenching, demolition, and heavy
              earthmoving.
            </p>
          </div>

          {/* Scissor Lifts */}
          <div className="group bg-brand-card rounded-lg p-8 border border-brand-border hover:border-t-4 hover:border-t-brand-orange hover:border-l-brand-border hover:border-r-brand-border hover:border-b-brand-border transition-all duration-300 cursor-pointer" data-id="element-271">
            <div className="w-14 h-14 rounded-lg bg-brand-orange/10 flex items-center justify-center mb-6" data-id="element-272">
              <ArrowUpFromLineIcon className="w-7 h-7 text-brand-orange" aria-hidden="true" data-id="element-273" />
            </div>
            <h3 className="font-oswald font-semibold text-xl uppercase text-white mb-3" data-id="element-274">
              Scissor Lifts
            </h3>
            <p className="text-brand-muted text-sm leading-relaxed" data-id="element-275">
              Electric and rough-terrain scissor lifts for elevated work at any
              height.
            </p>
          </div>

          {/* Trucks */}
          <div className="group bg-brand-card rounded-lg p-8 border border-brand-border hover:border-t-4 hover:border-t-brand-orange hover:border-l-brand-border hover:border-r-brand-border hover:border-b-brand-border transition-all duration-300 cursor-pointer" data-id="element-276">
            <div className="w-14 h-14 rounded-lg bg-brand-orange/10 flex items-center justify-center mb-6" data-id="element-277">
              <TruckIcon className="w-7 h-7 text-brand-orange" aria-hidden="true" data-id="element-278" />
            </div>
            <h3 className="font-oswald font-semibold text-xl uppercase text-white mb-3" data-id="element-279">
              Trucks
            </h3>
            <p className="text-brand-muted text-sm leading-relaxed" data-id="element-280">
              Dump trucks, flatbeds, and service trucks ready for the job site.
            </p>
          </div>

          {/* Trailers */}
          <div className="group bg-brand-card rounded-lg p-8 border border-brand-border hover:border-t-4 hover:border-t-brand-orange hover:border-l-brand-border hover:border-r-brand-border hover:border-b-brand-border transition-all duration-300 cursor-pointer" data-id="element-281">
            <div className="w-14 h-14 rounded-lg bg-brand-orange/10 flex items-center justify-center mb-6" data-id="element-282">
              <ContainerIcon className="w-7 h-7 text-brand-orange" aria-hidden="true" data-id="element-283" />
            </div>
            <h3 className="font-oswald font-semibold text-xl uppercase text-white mb-3" data-id="element-284">
              Trailers
            </h3>
            <p className="text-brand-muted text-sm leading-relaxed" data-id="element-285">
              Equipment trailers, tilt decks, and goosenecks to haul your
              machines.
            </p>
          </div>

          {/* Attachments */}
          <div className="group bg-brand-card rounded-lg p-8 border border-brand-border hover:border-t-4 hover:border-t-brand-orange hover:border-l-brand-border hover:border-r-brand-border hover:border-b-brand-border transition-all duration-300 cursor-pointer" data-id="element-286">
            <div className="w-14 h-14 rounded-lg bg-brand-orange/10 flex items-center justify-center mb-6" data-id="element-287">
              <WrenchIcon className="w-7 h-7 text-brand-orange" aria-hidden="true" data-id="element-288" />
            </div>
            <h3 className="font-oswald font-semibold text-xl uppercase text-white mb-3" data-id="element-289">
              Attachments
            </h3>
            <p className="text-brand-muted text-sm leading-relaxed" data-id="element-290">
              Buckets, breakers, augers, grapples, and more to maximize your
              machine.
            </p>
          </div>
        </div>
      </div>
    </section>;
}